<template>
	<div>
		<headinfo></headinfo>
		<!--中间内容-->
		<div class="center container">
		    <div class="center-nav">
		        <span class="hidden-xs">您的位置：</span>
		        <a href="/index.html">首页</a><i>&gt;</i>
		        <a title="所需材料" href="#">所需材料</a>
		    </div>
		    <div class="center-container">
		        <div class="center-container-left">
		            <div class="center-container-left-Ltitle">
		                <ul>
		                    <li v-for="(item,index) in tabledata">
		                        <a @click="showmatter(item)" class="active" title="所需材料" >{{item.matterName}}</a>
		                    </li>
		                </ul>
		                <div class="left-pic">
		                    <img src="./../assets/img/left-pic.png" alt="">
		                </div>
		            </div>
		        </div>
		        <div class="center-container-right">
		            <div class="center-container-right-title">
		                <span class="title">{{title}}</span>
						<!-- <el-button style="float: right;width: 15%;background-color:#E10200 ;" type="danger" round>
							<router-link style="color: #FFFFFF;text-decoration:none" :to="{name:'serve',params:{page:'3'}}">立即申办</router-link>
						</el-button> -->
		            </div>
		            <div class="center-container-right-words">
		                <h2>公证说明</h2>
		                <div class="content_box_s">
		                    <div class="content_box" v-html="content"></div>
		                </div>
						
						<div class="content_box_ss" v-if="filepath.length > 0">
							<div class="down_excel">常用表格下载:</div>
						    <a class="down_nn" :href="hoturl+item.url" v-for="(item,index) in filepath" >{{item.name}}</a>
						</div>
		            </div>
		        </div>
		    </div>
		</div>
		<!--底部导航-->
		<bottominfo></bottominfo>
	</div>
</template>

<script>
	import headinfo from '../components/headinfo.vue'
	import bottominfo from '../components/bottominfo.vue'
	import {getMatterList} from '../api/index.js'
	export default {
		name: "Personnel",
		components:{
			headinfo,
			bottominfo,
		},
		metaInfo: {
			title: '所需材料-邯郸市诚信公证处',
			meta: [{
				name: 'keyWords',
				content: '所需材料'
			}],
		},
		data() {
			return {
				open:false,
				tabledata:[],
				hoturl:'/cxWebApi/profile',
				info:null,
				title:'',
				filepath:[],
				content:'',
				pages:1,
			}
		},
		created() {
			this.pages = this.$route.params.page;
			this.getinfo();
		},
		methods:{
			showmatter(row){
				this.title = row.matterName;
				this.filepath = row.tableList;
				this.content = row.content;
			},
			getinfo(){
				getMatterList().then(res=>{
					this.tabledata = res.data
					this.tabledata.forEach((item,index)=>{
						if(item.id == this.pages){
							this.showmatter(this.tabledata[index]);
						}else{
							this.showmatter(this.tabledata[0]);
						}
					})
				})
			}
		}
	}
</script>

<style scoped>
	@import "../assets/css/reset.css";
	@import "../assets/css/new_file.css";
	>>> .ryjjdialog{
		min-height: 650px !important;
		border-radius: 10px;
	}
	>>> .ryjjdialog .el-dialog__header{
		padding: 0px !important;
	}
	>>> .ryjjdialog .el-dialog__body{
		padding: 0px !important;
	}
	>>>.center-container-right-words p{
		text-align: left !important;
		border-bottom:0px !important;
	}
	>>>.people-pic{
		height: 200px !important;
		min-height: 200 !important;
	}
	>>>.down_excel{
		padding: 20px 20px;
		font-size: 18px;
		font-weight: 600;
	}
	>>>.down_nn{
		padding: 0px 20px;
		color: #333333;
		font-weight: 600;
	}
	>>>.el-button{
		line-height: 0px !important;
	}
	>>>.center-container-right-words li{
		background:none !important;
	}
	>>>.content_box{
		text-indent: 2em; 
	}
	>>>.content_box strong{
		font-weight: 700;
	}
	>>>.content_box_ss{
		margin-bottom: 30px;
	}
</style>
